import IHwButtons from "./IHwButtons";
import AbstractStates from "../../states/AbstractStates";
import { injectable } from "inversify";

@injectable()
export default class BaseHwButtonsStates
	extends AbstractStates
	implements IHwButtons
{
	constructor() {
		super();
	}

	notify(eventName: string, data?: any, prevData?: any): Promise<any> | void {
		return undefined;
	}

	async turnOff() {}

	create() {}

	beforeSetState() {}

	stateBonus(data) {}

	stateBonusWin(data) {}

	stateBonusWheel(data) {}

	stateError(data) {}

	stateForcespin(data) {}

	stateFsIdle(data) {}

	stateIdle(data) {}

	stateInit(data) {}

	stateLoaded(data) {}

	statePreinfo(data) {}

	stateReady(data) {}

	stateSkip(data) {}

	stateSound(data) {}

	stateSearching(data) {}

	stateSpin(data) {}

	stateJokerBonusWin(data: any) {}
}
